import { defineMessages } from 'react-intl'

export const resultsPageMessages = defineMessages({
  results: {
    id: 'components.searchPage.results',
    defaultMessage: 'There are no results for your search'
  },
  matchedResults: {
    id: 'components.searchPage.matchedResults',
    defaultMessage: 'Results'
  },
  readMore: {
    id: 'components.searchPage.readMore',
    defaultMessage: 'Read more »'
  },
  seeAllArticles: {
    id: 'components.searchPage.seeAllArticles',
    defaultMessage: 'See all articles »'
  },
  resultCountOne: {
    id: 'components.searchPage.resultCount.one',
    defaultMessage: '{count} result'
  },
  resultCountMany: {
    id: 'components.searchPage.resultCount.many',
    defaultMessage: '{count} results'
  }
})

export const emptyStateMessages = defineMessages({
  noResults: {
    id: 'components.emptyState.noResults',
    defaultMessage: 'There are no results for your search "{query}"'
  },
  noResultsWithFilters: {
    id: 'components.emptyState.noResultsWithFilters',
    defaultMessage: 'We cannot find any results for "{query}" matching the selected filters'
  },
  suggestions: {
    id: 'components.emptyState.suggestions',
    defaultMessage: 'Suggestions'
  },
  suggestion1: {
    id: 'components.emptyState.suggestion1',
    defaultMessage: 'Make sure all the words are spelled correctly.'
  },
  suggestion2: {
    id: 'components.emptyState.suggestion2',
    defaultMessage: 'Try more general keywords.'
  },
  suggestion3: {
    id: 'components.emptyState.suggestion3',
    defaultMessage: 'Try fewer keywords.'
  },
  suggestion4: {
    id: 'components.emptyState.suggestion4',
    defaultMessage: 'Try different keywords.'
  },
  stillNotFound: {
    id: 'components.emptyState.stillNotFound',
    defaultMessage: "Still didn't find what you were looking for?"
  },
  sendFeedback: {
    id: 'components.emptyState.sendFeedback',
    defaultMessage: 'Send us your feedback'
  },
  goBack: {
    id: 'components.emptyState.goBack',
    defaultMessage: 'Go Back'
  },
  clearFilters: {
    id: 'components.emptyState.clearFilters',
    defaultMessage: 'Clear Filters'
  }
})
